<div class="choose-plan zk-w-full zk-flex zk-flex-wrap">
	<div class="xl:zk-w-6/12 lg:zk-w-6/12 md:zk-w-full">
		<section class="advantages-content">
			<h1 class="title">
				{{ 'SIGN_UP.CHOOSE_PLAN.TITLE' | translate }}
			</h1>
			<h5 class="description">
				{{ 'SIGN_UP.CHOOSE_PLAN.DESCRIPTION' | translate }}
			</h5>
			<ul>
				<div class="plan-advantages">
					<span
						class="freud-icon freud-icon-check freud-icon-md icon-check"
					></span>
					<li
						[innerHTML]="'SIGN_UP.CHOOSE_PLAN.FIRST_ADVANTAGE' | translate"
					></li>
				</div>
				<div class="plan-advantages">
					<span
						class="freud-icon freud-icon-check freud-icon-md icon-check"
					></span>
					<li [innerHTML]="'SIGN_UP.CHOOSE_PLAN.SECOND_ADVANTAGE' | translate">
						{{ 'SIGN_UP.CHOOSE_PLAN.DESCRIPTION' | translate }}
					</li>
				</div>
				<div class="plan-advantages">
					<span
						class="freud-icon freud-icon-check freud-icon-md icon-check"
					></span>
					<li [innerHTML]="'SIGN_UP.CHOOSE_PLAN.THIRD_ADVANTAGE' | translate">
						{{ 'SIGN_UP.CHOOSE_PLAN.DESCRIPTION' | translate }}
					</li>
				</div>
				<div class="plan-advantages">
					<span
						class="freud-icon freud-icon-check freud-icon-md icon-check"
					></span>
					<li [innerHTML]="'SIGN_UP.CHOOSE_PLAN.FOURTH_ADVANTAGE' | translate">
						{{ 'SIGN_UP.CHOOSE_PLAN.DESCRIPTION' | translate }}
					</li>
				</div>
			</ul>
		</section>
	</div>
	<div class="xl:zk-w-6/12 lg:zk-w-6/12 md:zk-w-full">
		<section class="plan-content">
			<article class="plan-card" [class.active]="isMonthPlanChoosed">
				<div class="plan-item">
					<button
						class="plan-button"
						name="plan-card-radio"
						(click)="choosingPlan('month')"
					></button>
					<p class="plan-text">Plano mensal</p>
				</div>
				<div class="plan-card-price">
					<span class="price">R$ 499</span>
					<span> por mês</span>
				</div>
			</article>
			<article class="plan-card" [class.active]="isAnnualPlanChoosed">
				<div class="plan-item">
					<button
						class="plan-button"
						name="plan-card-radio"
						(click)="choosingPlan('annual')"
					></button>
					<p class="plan-text">Plano anual</p>
				</div>
				<div class="plan-card-price">
					<div class="plan-card-price-from">
						<span>de </span>
						<span>R$ 5.988</span>
					</div>
					<div>
						<span>por </span>
						<span class="price">R$ 4.999</span>
						<span> por ano</span>
					</div>
				</div>
			</article>
			<div class="credit-card-note">
				<div>
					<span
						class="freud-icon freud-icon-credit-card icon-credit-card"
					></span>
				</div>
				<span
					class="note"
					[innerHTML]="
						'SIGN_UP.CHOOSE_PLAN.CREDIT_CARD_OBSERVATION' | translate
					"
				></span>
			</div>
		</section>
	</div>
</div>
